<script setup lang="ts">
const { initScroller, setupScrollers } = useMenuScroller();
</script>

<template>
  <div class="container relative block">
    <button
      data-scroll-left
      class="absolute h-[48px] w-[32px] lg:w-[48px] flex items-center justify-start left-0 top-0 -mt-[42px] md:-mt-[46px] bg-gradient-to-r from-white to-transparent py-2 pr-2 rounded-r hover:text-primary"
      :aria-label="$t('listing.category.ariaLabelScrollMenuLeft')"
    >
      <i class="fa fa-chevron-left font-bold text-base"></i>
    </button>

    <button
      data-scroll-right
      class="absolute h-[48px] w-[32px] lg:w-[48px] flex items-center justify-end right-0 top-0 -mt-[42px] md:-mt-[46px] bg-gradient-to-l from-white to-transparent py-2 pl-2 rounded-l hover:text-primary"
      :aria-label="$t('listing.category.ariaLabelScrollMenuRight')"
    >
      <i class="fa fa-chevron-right font-bold text-base"></i>
    </button>
  </div>
</template>
